import Text from '@/shared-components/text/components/Text';

import './styles/TimeOption.css';

export default function TimeOption({ text, isSelected, selectOption }) {
  return (
    <button
      type="button"
      className={`time-option__container element-non-selectable ${isSelected ? "selected" : ""}`}
      onClick={selectOption}
      aria-pressed={isSelected}
    >
      <div className="time-option__indicator" />

      <Text className="time-option__text">
        {text}
      </Text>
    </button>
  );
}
